import React from "react";
import { FormattedMessage } from "react-intl";
import { Col } from "reactstrap";
import {
  type IIntegrationDetailShopifyProps,
  IntegrationDetailShopify,
} from "src/integrations/components/shopify/IntegrationDetailShopify";
import { Formatter } from "src/shared/formatters/Formatter";

export const IntegrationDetailShopifyForm = (
  props: IIntegrationDetailShopifyProps,
) => {
  const { integration, children } = props;
  return (
    <IntegrationDetailShopify {...props}>
      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.shopifyForms.metaobjectType" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter>{integration.metaobjectType}</Formatter>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.shopify.isRestricted" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter>{integration.isRestricted}</Formatter>
      </Col>

      {children}
    </IntegrationDetailShopify>
  );
};
